const navigationData = {

    104: {
      date: "",
      mobileNo: "",
      masterScheme: "",
      subSchemeName: "",
    },
    105: {
      mobileNo: "",
      passBookNo: "",
    },
  
};

const initialState = {
  holdPrePageData: navigationData,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "Update_MobileNo":
      return {
        ...state,
        holdPrePageData: {
          ...state.holdPrePageData,
          104: {
            ...state.holdPrePageData[104],
            mobileNo: payload?.mobileNo,
            masterScheme: payload?.masterScheme,
            subSchemeName: payload?.subSchemeName,
          },
        },
      };

    case "Report_Navigation":
      return {
        ...state,
        holdPrePageData: {
          ...state.holdPrePageData,
          104: {
            ...state.holdPrePageData[104],
            ...payload,
          },
        },
      };
      case "navigation_Reset_values":
        return{
          ...state,
          holdPrePageData:navigationData

          
        }
    default:
      return state;
  }
};

export default reducer;
